import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { CustomerUsersService } from 'src/app/services/customerUsers.service';
import { RoleLevel } from 'src/app/shared/enums/role-level.enum';
import { UserDetails } from '../../services/dtos/userDetails';
import { AddUserName, FetchUserDetailsIfEmpty, RemoveUserName } from './user.actions';

export class UserStateModel {
  public userName!: string;
  public userRole!: string;
  public userRoleLevel!: RoleLevel;
  public rights!: string[];
}

const defaults = {
  userName: '',
  userRole: '',
  userRoleLevel: RoleLevel.user,
  rights: []
};

@State<UserStateModel>({
  name: 'userState',
  defaults
})

@Injectable()
export class UserState {
  public constructor(private customerUsersService: CustomerUsersService) { }

  @Selector()
  public static getUserName(state: UserStateModel): string {
    return state.userName;
  }

  @Selector()
  public static getUserDetails(state: UserStateModel): string {
    return state.userRole;
  }

  @Selector()
  public static getUserRoleLevel(state: UserStateModel): RoleLevel {
    return state.userRoleLevel;
  }

  @Selector()
  public static getUserRights(state: UserStateModel): string[] {
    return state.rights;
  }

  @Action(AddUserName)
  public addUserName({ getState, setState }: StateContext<UserStateModel>, { userName }: AddUserName): void {
    const state = getState();
    setState({ ...state, userName });
  }

  @Action(RemoveUserName)
  public removeUserName({ getState, setState }: StateContext<UserStateModel>): void {
    const state = getState();
    setState({ ...state, userName: '' });
  }

  @Action(FetchUserDetailsIfEmpty)
  public fetchUserDetails({ getState, setState }: StateContext<UserStateModel>): Observable<UserDetails> | void {
    const state = getState();
    if (!state.userRole) {
      return this.customerUsersService.getUserDetails()
        .pipe(
          tap((user: UserDetails) => {
            setState({
              ...state,
              userRole: user.role,
              userRoleLevel: user.roleLevel,
              userName: user.name,
              rights: user.rights
            });
          }));
    }
  }
}
